import { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import Container from "../Container/Container";
import "./DraggableList.css";
import GroupDraggable from "./GroupDraggable";

const DraggableList = (props) => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    setGroups(props.initialGroups);
  }, [props.initialGroups]);

  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) {
      return;
    }
    const sourceGroupId = parseInt(source.droppableId);
    const destinationGroupId = parseInt(destination.droppableId);
    const newGroups = [...groups];

    if (sourceGroupId === destinationGroupId) {
      const updatedItems = reorderItems(
        groups[sourceGroupId].items,
        source.index,
        destination.index
      );
      newGroups[sourceGroupId].items = updatedItems;
    } else {
      const result = moveItem(
        groups[sourceGroupId].items,
        groups[destinationGroupId].items,
        source,
        destination
      );
      newGroups[sourceGroupId].items = result[sourceGroupId];
      newGroups[destinationGroupId].items = result[destinationGroupId];
    }
    setGroups(newGroups);
  };

  const reorderItems = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const moveItem = (
    source,
    destination,
    droppableSource,
    droppableDestination
  ) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
  };

  const deleteItem = (groupId, itemId) => {
    const newGroups = [...groups];
    newGroups[groupId].items.splice(itemId, 1);
    setGroups(newGroups);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      {groups?.map((group, groupId) => (
        <Container className="draggable-list-container" key={groupId}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div />
            <h1 className="draggable-list-group-name">{group.name}</h1>
            <GroupDraggable
              groupId={groupId}
              items={group.items}
              deleteItem={deleteItem}
            />
          </div>
        </Container>
      ))}
    </DragDropContext>
  );
};

export default DraggableList;
